import React, { useState } from "react"
import VizSensor from "react-visibility-sensor"

import * as s from "./AnimateWrapper.module.scss"

interface iAnimateWrapper {
  className?: string
  children: React.ReactNode
}

export const AnimateWrapper = ({ className, children }: iAnimateWrapper) => {
  const [visibilityClass, setVisibilityClass] = useState(false)

  const onChangeVisibility = isActive => {
    if (isActive) {
      setVisibilityClass(true)
    }
  }

  return (
    <VizSensor partialVisibility onChange={e => onChangeVisibility(e)}>
      <div
        className={`${className && className} ${s.AnimateWrapper} ${
          visibilityClass && s.AnimateWrapper__visible
        }`}
      >
        {children}
      </div>
    </VizSensor>
  )
}
